import { connect }     from 'react-redux';
import { Dispatch }    from "redux";
import { ActionTypes } from 'actions/types';
import { reducerType } from 'reducer';
import { words }       from 'utils/dictionary';
import { colors }      from 'utils/colors';
import { makeStyles }  from 'makeStyles';

const useStyles = makeStyles()(({
  container: {    
    width:          '100%',
    height:         '100%',
    display:        'flex',
    flexFlow:       'column',
  },
  form: {
    paddingBottom:  5,
    flex:           1,
    width:          '100%',
    display:        'flex',
    flexFlow:       'column',
   // justifyContent: 'felx-start',
    justifyContent: 'center',
    alignItems:     'center',
  },
  label: {
      marginTop:    5,
      marginBottom: 20,
      textAlign:    'center',
      fontSize:     20,
    },
  text_field: {
    fontSize:        16,
    height:          45,
    color:           colors.darkText,
    marginBottom:    10, 
  },
  err: {
   marginTop:      20,
   fontSize:       19, 
   display:        'flex',
   justifyContent: 'center',
   alignItems:     'center',
   textAlign:      'center',
   height:         30,
   color:          '#F00',
 }
}));


type TextInputProps = {
    lang:            string;
    error:           string;
    lessonNumber:    string;
    setLessonNumber: (val: string) => void;
    setError:        (val: string) => void;
}

export const TextInput: React.FC<TextInputProps> = ({
     lang,
     error,
     lessonNumber,
     setLessonNumber,
     setError,
}) => { 

  const { classes } = useStyles();

  const changeInputValue = (e: React.FormEvent) => {

    e.preventDefault();
    
    const target = e.target as HTMLInputElement;

    if (!isNaN(+target.value)) {
      setLessonNumber(target.value.trim()) 
      if (!!error.length) {
        setError('')
      }
    }

    else {
      setError(words['onlyNumbersAlowd'][lang])
    }
  }
 

  return (
      <div className = { classes.container }>       
          <div className = { classes.err }> 
             { error } 
          </div>
            <form className = { classes.form }>
                <div 
                  className = { classes.label }
                  dir       = 'rtl'
                >
                  { words['enterLessonNum'][lang] }
                </div>
                <input
                  dir         = 'rtl'
                  className   = { classes.text_field }
                  data-testid = { "LessonNum" }
                  id          = "LessonNum"
                  value       = { lessonNumber }
                  onChange    = { changeInputValue }
                />                
            </form>
      </div>
    )
  
}



const mapStateToProps = (reducer: reducerType) => {

  return {
     lang: reducer.components.lang
}};

const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
  //registerEmail:       (payload: { userName: string, userEmail: string }) => dispatch(REGISTER_EMAIL_SAGA(payload)),
  //setManualNavState:   (payload: manualNavStateType) => dispatch(SET_MANUAL_NAV_STATE(payload)),
  //logOut:              () => dispatch(LOG_OUT_SAGA())
});

export default connect(mapStateToProps, mapDispatchToProps)(TextInput);




